export const environment = {
    production: true,
    baseUrl: '/integration/simulator/',
    apiUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}${'/doku/simulator/v1/'}`,
    walletApiUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}${'/doku/simulator/wallet/'}`,
    indomaretUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}${'/VASimulator/IndomartAction_show.doku'}`,
    bniUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}${'/VASimulator/BNIAction_show.doku'}`,
    bncUrl: `${window.location.protocol}//${window.location.hostname}:${window.location.port}${'/VASimulator/BNCAction_show.doku'}`,
    hostUrl: 'http://dev.dokupay.com',
    hostName: `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    dokuFramework: '/doku-ui-framework/',
    loginPage: '/bo/login/',
    activeChannels: [
        {
            'path': 'bca',
            'description': 'Bank BCA',
            'imagePath': 'bank/bca.png',
            'type': 'bank'
        },
        {
            'path': 'bri',
            'description': 'Bank BRI',
            'imagePath': 'bank/bri.png',
            'type': 'bank'
        },
        {
            'path': 'bri-snap',
            'description': 'Bank Bri (SNAP)',
            'imagePath': 'bank/bri.png',
            'type': 'bank'
        },
        {
            'path': 'mandiri',
            'description': 'Bank Mandiri',
            'imagePath': 'bank/mandiri.png',
            'type': 'bank'
        },
        {
            'path': 'mandiri-snap',
            'description': 'Bank Mandiri (SNAP)',
            'imagePath': 'bank/mandiri.png',
            'type': 'bank'
        },
        {
            'path': 'mandiri-syariah',
            'description': 'Bank Syariah Indonesia',
            'imagePath': 'bank/mandirisyariah.png',
            'type': 'bank'
        },
        {
            'path': 'permata',
            'description': 'Bank Permata',
            'imagePath': 'bank/permata.png',
            'type': 'bank'
        },
        {
            'path': 'danamon',
            'description': 'Bank Danamon',
            'imagePath': 'bank/danamon.png',
            'type': 'bank'
        },
        {
            'path': 'danamon-snap',
            'description': 'Bank Danamon (SNAP)',
            'imagePath': 'bank/danamon.png',
            'type': 'bank'
        },
        {
            'path': 'cimb',
            'description': 'Bank CIMB',
            'imagePath': 'bank/cimb.png',
            'type': 'bank'
        },
        {
            'path': 'doku-va',
            'description': 'ALTO, ATM Bersama, Prima (DOKU VA)',
            'imagePath': 'bank/doku_va.png',
            'type': 'bank'
        },
        {
            'path': 'bni',
            'description': 'BNI',
            'imagePath': 'bank/bni.png',
            'type': 'bank'
        },
        {
            'path': 'bni-snap',
            'description': 'BNI (SNAP)',
            'imagePath': 'bank/bni.png',
            'type': 'bank'
        },
        {
            'path': 'bnc',
            'description': 'BNC',
            'imagePath': 'bank/neo-commerce-sm.png',
            'type': 'bank'
        },
        {
            'path': 'btn',
            'description': 'BTN',
            'imagePath': 'bank/btn.png',
            'type': 'bank'
        },
        {
            'path': 'credit-card',
            'description': 'Credit Card',
            'imagePath': 'card/all.png',
            'type': 'credit-card'
        },
        {
            'path': 'direct-debit-bri',
            'description': 'Direct Debit BRI',
            'imagePath': 'bank/bri.png',
            'type': 'direct-debit'
        },
        {
            'path': 'ovo',
            'description': 'OVO',
            'imagePath': 'ewallet/OVO.png',
            'type': 'ewallet'
        },
        {
            'path': 'shopeepay',
            'description': 'Shopee Pay',
            'imagePath': 'ewallet/ShopeePay.png',
            'type': 'ewallet'
        },
        {
            'path': 'linkaja',
            'description': 'LinkAja',
            'imagePath': 'ewallet/Linkaja.png',
            'type': 'ewallet'
        },
        {
            'path': 'alfa',
            'description': 'Alfamart',
            'imagePath': 'convenience/alfamart.png',
            'type': 'store'
        },
        {
            'path': 'indomaret',
            'description': 'Indomaret',
            'imagePath': 'convenience/indomaret.png',
            'type': 'store'
        },
        {
            'path': 'direct-transfer-bca',
            'description': 'Direct Transfer BCA',
            'imagePath': 'bank/bca.png',
            'type': 'direct-transfer'
        },
        {
            'path': 'rekening-bersama-bca',
            'description': 'REKBER BCA',
            'imagePath': 'bank/bca.png',
            'type': 'rekening-bersama'
        },
        {
            'path': 'paylater-akulaku',
            'description': 'Akulaku',
            'imagePath': 'financing/akulaku.png',
            'type': 'paylater'
        },
        {
            'path': 'paylater-kredivo',
            'description': 'Kredivo',
            'imagePath': 'financing/kredivo.png',
            'type': 'paylater'
        },
        {
            'path': 'paylater-indodana',
            'description': 'Indodana',
            'imagePath': 'financing/indodana.png',
            'type': 'paylater'
        },
        {
            'path': 'maybank-snap',
            'description': 'Bank Maybank (SNAP)',
            'imagePath': 'bank/maybank.png',
            'type': 'bank'
        },
        {
            'path': 'permata-snap',
            'description': 'Bank Permata (SNAP)',
            'imagePath': 'bank/permata.png',
            'type': 'bank'
        },
        {
            'path': 'klik-bca',
            'description': 'KlikBCA',
            'imagePath': 'bank/bcaklikpay.png',
            'type': 'internet'
        },
        {
            'path': 'bsi-snap',
            'description': 'Bank BSI (SNAP)',
            'imagePath': 'bank/mandirisyariah.png',
            'type': 'bank'
        }
    ]
};
